<template>
  <div class="login-page">
    <div class="login-box">
      <h2 class="login-title">CatBit Admin</h2>
      <form @submit.prevent="submit">
        <div class="login-field">
          <label>Логин или Email</label>
          <input
            v-model="login"
            type="text"
            autocomplete="username"
            placeholder="Введите логин или email"
            :disabled="loading"
          />
        </div>
        <div class="login-field">
          <label>Пароль</label>
          <input
            v-model="password"
            type="password"
            autocomplete="current-password"
            placeholder="Введите пароль"
            :disabled="loading"
          />
        </div>
        <p v-if="error" class="login-error">{{ error }}</p>
        <button type="submit" :disabled="loading" class="login-btn">
          {{ loading ? "Вход..." : "Войти" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { loginAdmin } from "@/api";
import { mapMutations } from "vuex";

export default {
  name: "Login",

  data: () => ({
    login: "",
    password: "",
    error: "",
    loading: false,
  }),

  methods: {
    ...mapMutations("auth", ["setSession"]),

    async submit() {
      this.error = "";
      if (!this.login || !this.password) {
        this.error = "Заполните все поля";
        return;
      }
      this.loading = true;
      try {
        const res = await loginAdmin(this.login, this.password);
        const result = res.data.result;
        localStorage.setItem("Auth", JSON.stringify(result));
        this.setSession(result);
        if (result.mustChangePassword) {
          this.$router.push("/change-password");
        } else {
          this.$router.push("/");
        }
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.message;
        this.error = msg || "Неверный логин или пароль";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(36, 40, 44);
}

.login-box {
  background: rgb(45, 50, 56);
  border-radius: 8px;
  padding: 40px 36px;
  width: 360px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
}

.login-title {
  text-align: center;
  color: rgb(239, 214, 169);
  margin-bottom: 28px;
  font-size: 22px;
  font-family: verdana;
  font-weight: normal;
  letter-spacing: 1px;
}

.login-field {
  margin-bottom: 16px;
}

.login-field label {
  display: block;
  color: #aaa;
  font-size: 12px;
  margin-bottom: 6px;
  font-family: verdana;
}

.login-field input {
  width: 100%;
  padding: 10px 12px;
  background: rgb(36, 40, 44);
  border: 1px solid #444;
  border-radius: 4px;
  color: #e0e0e0;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  font-family: verdana;
}

.login-field input:focus {
  border-color: rgb(239, 214, 169);
}

.login-error {
  color: #e57373;
  font-size: 12px;
  margin-bottom: 12px;
  font-family: verdana;
}

.login-btn {
  width: 100%;
  padding: 11px;
  background: rgb(239, 214, 169);
  color: rgb(36, 40, 44);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-family: verdana;
  cursor: pointer;
  margin-top: 4px;
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-btn:hover:not(:disabled) {
  background: #f0d9a0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue